import type { RotasDoModulo } from '@/app/rotas';
import { PlatformLayout } from '@/features/platform/PlatformLayout';

import { CreditSettingsPage } from './CreditSettingsPage';
import { PlatformCreditParametersPage } from './PlatformCreditParametersPage';

/**
 * Configuracao da analise de credito.
 *
 * A pagina da empresa fica dentro de Configuracoes, na moldura da empresa. A do
 * padrao global fica na administracao da plataforma, com a moldura dela: o caminho
 * /admin/credito e mais especifico que o /admin, e o React Router o escolhe.
 */
export const rotas: RotasDoModulo = {
  moldura: [{ path: '/configuracoes/credito', element: <CreditSettingsPage /> }],
  avulsas: [
    {
      path: '/admin/credito',
      element: <PlatformLayout />,
      exigeSessao: true,
      filhas: [{ path: 'parametros', element: <PlatformCreditParametersPage /> }],
    },
  ],
};
